import { doc, updateDoc } from 'firebase/firestore'
import { firebase_firestore } from '../firebaseConfig'
import { Pattern } from '../../app/builder/contexts/PatternContext'

// Soft-delete only, for both personal and standard patterns — the doc and its
// version history are left intact so existing alerts can always resolve
// version history, and the pattern can be restored later. Never hard-delete.
export async function deletePattern(
  pattern: Pattern,
  isTradingHousePattern: boolean | undefined,
  usermeta: any
): Promise<void> {
  if (isTradingHousePattern && !usermeta.isAdmin) {
    // Unreachable from the UI today (the delete action is admin-gated before this is
    // ever called) — throw rather than return, so a caller's success toast can never
    // fire for a delete that didn't actually write anything.
    throw new Error('Only admins can delete a standard pattern')
  }

  const docPath = isTradingHousePattern
    ? `tradingHouses/${pattern.tradingHouse}/standardPatterns/${pattern.id}`
    : `usermeta/${usermeta.gcid}/patterns/${pattern.id}`

  await updateDoc(doc(firebase_firestore, docPath), { deleted: true, active: false })
}
